import find from 'lodash/find';
import { createReducer } from 'redux-act';
import { feedSuccess } from './feeds';
import { compareDisplayName } from './utils';

const initState = {
  makeModelsDict: {},
};

export const getModelsYearsStore = (store) => store ? store.modelsYears || store : initState;

export const getModelsForMake = (makeId, state) => {
  const modelsYearsStore = getModelsYearsStore(state);
  const { makeModelsDict } = modelsYearsStore;
  return makeModelsDict[makeId] || [];
};

export const getYearsForModel = (models, modelId) => {
  const foundModel = find(models, model => model.modelId === modelId);
  if (!models || modelId === undefined || !foundModel) {
    return [];
  }
  const { years } = foundModel;
  return years;
};

export const getModelFromId = (models, modelId) => {
  if (!models) {
    return undefined;
  }
  return models
    .filter(model => model.modelId === modelId)
    .pop();
};

const toStringProto = {
  toString() {
    return this.displayName;
  },
};

const createModelObj = ({ model: displayName, id: modelId, yearSet }) => {
  const years = Array.from(yearSet).sort((a, b) => b - a);
  return Object.assign(Object.create(toStringProto), { displayName, modelId, years });
};

const getModelYearsFromFeed = (feed) => {
  const map = feed.reduce((dict, row) => {
    const { year, model } = row;
    if (!model || !year) {
      return dict;
    }

    if (!dict.has(model)) {
      dict.set(model, new Set());
    }

    dict.get(model).add(year);
    return dict;
  }, new Map());

  const models = [];
  let idx = 0;
  map.forEach((yearSet, model) => {
    models.push(createModelObj({ model, yearSet, id: idx }));
    idx++;
  });
  return models
    .sort(compareDisplayName);
};

const handleFeedSuccess = (state, { makeId, feed }) => {
  const makeModelsDict = Object.assign({}, state.makeModelsDict, { [makeId]: getModelYearsFromFeed(feed) });
  return Object.assign({}, state, { makeModelsDict });
};

export default createReducer({
  [feedSuccess]: handleFeedSuccess,
}, initState);



// WEBPACK FOOTER //
// ./src/main/data/models-years.js